import { render, staticRenderFns } from "./ShapeShiftTaskInput.vue?vue&type=template&id=4553360a&scoped=true"
import script from "./ShapeShiftTaskInput.vue?vue&type=script&lang=js"
export * from "./ShapeShiftTaskInput.vue?vue&type=script&lang=js"
import style0 from "./ShapeShiftTaskInput.vue?vue&type=style&index=0&id=4553360a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553360a",
  null
  
)

export default component.exports